<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑轮播图' : '添加轮播图'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="100px">

			<el-form-item label="图片">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('image', value)"
						:show-file-list="false"
						:action="app_url + '/store/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.image"></i>
					<img :src="item.image" v-else>
				</el-upload>
			</el-form-item>

			<el-form-item label="位置">
				<el-radio @change="changeType" v-model="item.url_type" label="0">无跳转</el-radio>
				<el-radio @change="changeType" v-model="item.url_type" label="1">商品分类</el-radio>
				<el-radio @change="changeType" v-model="item.url_type" label="2">商品</el-radio>
			</el-form-item>

			<el-form-item label="商品分类" v-if="item.url_type == 1">
				<el-select v-model="item.url_id" clearable  filterable placeholder="请选择">
				    <el-option
				      v-for="item in classify"
				      :label="item.name"
				      :value="item.id">
				    </el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品" v-else-if="item.url_type == 2">
				<el-select v-model="item.url_id" clearable  style="width: 800px;" filterable placeholder="请选择">
				    <el-option
				      v-for="item in goods"
				      :label="item.name"
				      :value="item.goods_id.toString()">
				    </el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="位置">
				<el-radio v-model="item.positions" label="1">首页头部(750px x 300px)</el-radio>
				<el-radio v-model="item.positions" label="2">首页中部(750px x 300px)</el-radio>
				<el-radio v-model="item.positions" label="4">商品页面(500px x 250px)</el-radio>
				<el-radio v-model="item.positions" label="5">我的页面(690px x 200px)</el-radio>
			</el-form-item>

			<el-form-item label="排序">
				<el-input placeholder="请输入排序" v-model="item.orders"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				item: {
					positions: '1',
					url_type:'0'
				},
				isLoad: false,
				dialogVisible: false,
				id: this.$route.query.id,
				dialogVisibleCarousel: false,
				pic: [],
				classify:[],
				goods:[],
				rules: {
					image: [
					    {required: true, message: '首页轮播图不存在'},
					],
				},
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
			this.getData()
		},
		methods: {
			loadData: function() {
				if (this.isLoad) {
					return
				}
				if (!this.id) {
					return
				}
				this.isLoad = !this.isLoad

				// 获取轮播图信息
				this.axios.post('/store/fitment.swiper/detail', {
					id: this.id
				}).then(res => {
					this.isLoad = !this.isLoad
					// item是基础信息
					this.item = res.data.detail
					this.item.positions = this.item.positions.toString()
					this.item.url_type = this.item.url_type.toString()
					// this.item.url_id = this.item.url_id.toString()
					this.$forceUpdate()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			getData(){
				// 分类
				this.axios.get('/store/data/getCategoryTreeStore', {}).then(res => {
					this.classify = res.data.list
				})

				// 商品
				this.axios.post('/store/product/listProductsForSwiperSelect', {}).then(res => {
					this.goods = res.data.list
					this.$forceUpdate()
				})
			},
			changeType(e){
				this.$set(this.item,'url_id', '')
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false

				let url = ''
				if (this.id) {
					url = '/store/fitment.swiper/edit'
					this.item.id = this.id
				} else {
					url = '/store/fitment.swiper/add'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			//上传失败通用
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
				this.$forceUpdate()
			},
			//图片移除 非通用
			uploadRemove: function() {
				this.pic = []
			},
			//格式检查 通用
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
		}
	}
</script>

<style>
</style>
